module.exports = __webpack_public_path__ + "img/BillerCN.9686c581.png";